import {noop} from '@github-ui/noop'
import {BaseStyles} from '@primer/styled-react'
import {useEffect, useEffectEvent} from 'react'
import {createPortal} from 'react-dom'

import {useLazyRef} from '../../hooks/common/use-lazy-ref'

export const Portal: React.FC<{onMount?: () => void; id?: string; children: React.ReactNode}> = ({
  children,
  id,
  onMount: onMountProp = noop,
}) => {
  const onMount = useEffectEvent(onMountProp)
  const el = useLazyRef(() => document.createElement('div'))
  if (id) el.current.setAttribute('id', id)

  useEffect(() => {
    const element = el.current
    const parentEl = document.getElementById('portal-root')

    parentEl?.appendChild(element)
    onMount()

    return function cleanup() {
      parentEl?.removeChild(element)
    }
  }, [el])

  return createPortal(<BaseStyles style={{display: 'contents'}}>{children}</BaseStyles>, el.current)
}
